import React from "react";
import { useEffect } from "react";
import NewsItem from "./NewsItem";
// import Spinner from "./Spinner";
import PropTypes from "prop-types";
// import InfiniteScroll from "react-infinite-scroll-component";
import { useState } from "react";
// import image from "./News.webp";

const News = (props) => {
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [totalResults, setTotalResults] = useState(0);
  // const variable = process.env.REACT_APP_NEWS_API;
  const capitalizeFirst = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };

  const updateNews = async () => {
    props.setProgress(0);
    // let url = `https://newsapi.org/v2/top-headlines?country=${props.country}&category=${props.category}&apiKey=ee647730b6a8493badcfe9ae2055bdd0&page=${props.page}&pageSize=${props.pageSize}`;
    let url = `https://newsapi.in/newsapi/news.php?key=QbWT02Yz4xhN1eneZyewRnrPvwrpTn&category=india_english${
      props.category === "" ? props.category : "_" + props.category
    }`;
    setLoading(true);
    let data = await fetch(url);

    props.setProgress(30);
    let parsedData = await data.json();
    props.setProgress(50);
    setArticles(parsedData.News);
    setLoading(false);
    // setTotalResults(parsedData.totaflResults);
    props.setProgress(100);
  };

  useEffect(() => {
    updateNews();
  }, []);

  // const fetchMoreData = async () => {
  //   // let url = `https://newsapi.org/v2/top-headlines?country=${
  //   //   props.country
  //   // }&category=${props.category}&apiKey=${props.apiKey}&page=${
  //   //   page + 1
  //   // }&pageSize=${props.pageSize}`;
  //   // setPage(page + 1);
  //   let url = `https://newsapi.in/newsapi/news.php?key=QbWT02Yz4xhN1eneZyewRnrPvwrpTn&category=india_english_${props.category}`;

  //   let data = await fetch(url);

  //   let parsedData = await data.json();

  //   setArticles(articles.concat(parsedData.News));
  //   // setTotalResults(parsedData.News);
  // };

  return (
    <>
      <h1 className="text-center" style={{ margin: "35px", marginTop: "90px" }}>
        New Monkey - Top {capitalizeFirst(props.category)} Headlines
      </h1>
      {/* <InfiniteScroll
        dataLength={articles.length}
        next={fetchMoreData}
        // hasMore={articles.length !== totalResults}
        loader={<Spinner />}
      > */}
      <div className="container">
        {/* {props.loading && <Spinner />} */}
        <div className="row">
          {articles.map((element) => {
            return (
              <div className="col-md-3" key={element.url}>
                <NewsItem
                  title={element.title}
                  description={element.description}
                  imageUrl={element.image}
                  newsUrl={element.url}
                  // author={element.author}
                  date={element.published_date}
                  // source={element.source.name}
                />
              </div>
            );
          })}
        </div>
      </div>
      {/* </InfiniteScroll> */}
    </>
  );
};

News.defaultProps = {
  country: "in",
  pageSize: 8,
  category: "general",
};

News.propType = {
  country: PropTypes.string,
  pageSize: PropTypes.number,
};

export default News;
